import { render, staticRenderFns } from "./ManagingPeople.vue?vue&type=template&id=25ce3be2&scoped=true"
import script from "./ManagingPeople.vue?vue&type=script&lang=js"
export * from "./ManagingPeople.vue?vue&type=script&lang=js"
import style0 from "./ManagingPeople.vue?vue&type=style&index=0&id=25ce3be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce3be2",
  null
  
)

export default component.exports